export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $(".btn--calculate").click(function (e) {
      e.preventDefault();
      var quantityinput = $("input.qty");
      if ($(this).data("calculate") == "minus") {
        if (quantityinput.val() > 1) {
          quantityinput.val(parseInt(quantityinput.val()) - 1);
        }
      } else {
        quantityinput.val(parseInt(quantityinput.val()) + 1);
      }
      quantityinput.trigger("change");
    });
    $(".discountbox_one").click(function (e) {
      e.preventDefault();
      var quantityinput = $("input.qty");
      quantityinput.val(1);
      quantityinput.trigger("change");
    });
    $(".discountbox_three").click(function (e) {
      e.preventDefault();
      var quantityinput = $("input.qty");
      quantityinput.val(3);
      quantityinput.trigger("change");
    });
    $(".discountbox_five").click(function (e) {
      e.preventDefault();
      var quantityinput = $("input.qty");
      quantityinput.val(5);
      quantityinput.trigger("change");
    });

    if ($("#addtocartmodal").length) {
      $("#addtocartmodal").modal("show");
    }

    $("input.qty, input.tmcp-field").change(function () {
      if ($(".js-no-variation").length) {
        var price_html = parseFloat(
          $(".js-no-variation").text() * $(".qty").val()
        );

        if ($("input.tmcp-field").length) {
          $("input.tmcp-field:checked").each(function () {
            price_html += parseFloat(
              $(this).closest(".tmcp-field-wrap").find(".tc-price").text() *
                $(".qty").val()
            );
          });
        }

        price_html += price_html.toString().indexOf(",") > 0 ? "" : ",-";
        $("form.cart p.price").html(price_html);
      }
    });

    $("form.variations_form").on("show_variation", function () {
      // for variations that don't have pa_vorm custom hide price if variation is selected
      $(".woocommerce-variation-add-to-cart p.price").slideUp(200);
    });

    if ($(".variationstep_options").length == 1) {
      $(".tc-extra-product-options").addClass("shown");
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/product.js